import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";
import type { HomeSummary } from "../types/home";

export const homeApi = createApi({
  reducerPath: "homeApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["HomeSummary"],
  endpoints: (builder) => ({
    getHomeSummary: builder.query<HomeSummary, void>({
      query: () => "/home/summary",
      transformResponse: (raw: { status: string; data: HomeSummary }) =>
        raw.data,
      providesTags: ["HomeSummary"],
    }),
  }),
});

export const { useGetHomeSummaryQuery } = homeApi;
